/* tslint:disable */
/* eslint-disable */
/**
 * EvictorAPI API
 * EvictorAPI handles Evictor operations for the target cluster.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Expression is a proto mirror of the metav1.LabelSelectorRequirement K8s API object.
 * @export
 * @interface LabelSelectorExpression
 */
export interface LabelSelectorExpression {
    /**
     * Key is a label.
     * @type {string}
     * @memberof LabelSelectorExpression
     */
    'key': string;
    /**
     * Operator is the key\'s relationship to the values.
     * @type {string}
     * @memberof LabelSelectorExpression
     */
    'operator': LabelSelectorExpressionOperatorEnum;
    /**
     * Values is an array of string values. If the operator is In or NotIn, the values array must be non-empty. If the  operator is Exists or DoesNotExist, the values array must be empty.
     * @type {Array<string>}
     * @memberof LabelSelectorExpression
     */
    'values'?: Array<string>;
}

export const LabelSelectorExpressionOperatorEnum = {
    OPERATOR_UNSPECIFIED: 'OPERATOR_UNSPECIFIED',
    IN: 'IN',
    NOT_IN: 'NOT_IN',
    EXISTS: 'EXISTS',
    DOES_NOT_EXIST: 'DOES_NOT_EXIST'
} as const;

export type LabelSelectorExpressionOperatorEnum = typeof LabelSelectorExpressionOperatorEnum[keyof typeof LabelSelectorExpressionOperatorEnum];


